import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const SignupPage = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const handleSignup = () => {
        const users = JSON.parse(localStorage.getItem("users")) || [];

        users.push({ name, email, password });

        localStorage.setItem("users", JSON.stringify(users));

        alert("Signup Successful!");

        navigate("/");
    };

    return (
        <div className="flex h-screen items-center justify-center bg-gray-100">
            <div className="bg-white p-6 rounded-lg shadow w-80">
                <h2 className="text-xl font-bold mb-4">Signup</h2>

                <input
                    type="text"
                    placeholder="Name"
                    className="w-full mb-3 p-2 border rounded"
                    onChange={(e) => setName(e.target.value)}
                />

                <input
                    type="email"
                    placeholder="Email"
                    className="w-full mb-3 p-2 border rounded"
                    onChange={(e) => setEmail(e.target.value)}
                />

                <input
                    type="password"
                    placeholder="Password"
                    className="w-full mb-3 p-2 border rounded"
                    onChange={(e) => setPassword(e.target.value)}
                />

                <button
                    className="w-full bg-green-500 text-white p-2 rounded"
                    onClick={handleSignup}
                >
                    Signup
                </button>
            </div>
        </div>
    );
};

export default SignupPage;